// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tabs_wrapper__v_U88","tabs":"tabs_tabs__TEe3v","tab":"tabs_tab__IbQCi"};